import { render } from "./CompanyRemindersList.vue?vue&type=template&id=2529484f"
import script from "./CompanyRemindersList.vue?vue&type=script&lang=js"
export * from "./CompanyRemindersList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__